// Fuente única del importe facturable (ingreso reconocido).
// Aplica el descuento de acuerdo (ej. OMNET 25%) sobre el importe congelado.
// Shape-agnostic: sirve para sales y para objetos-mes de sales_contratos
// (que reciben descuento_acuerdo_pct por threading, regla 10.127).
// NULL/0 → devuelve importe sin cambios (ventas no-acuerdo).
export function getImporteFacturable(obj) {
  const importe = parseFloat(obj?.importe) || 0;
  const desc = parseFloat(obj?.descuento_acuerdo_pct) || 0;
  return importe * (1 - desc);
}

// Tolerancia (en pesos de moneda local) para comparar el neto del DTE contra el facturable:
// absorbe el redondeo del SII. Ej.: DTE 493 = 1.534.706 vs facturable 1.534.685 → 21 < 100 → OK.
// La usan el badge de divergencia (VentasFacturas) y el guardrail de vinculación (conciliacionSII).
export const TOLERANCIA_MONTO_FACTURABLE = 100;
